export const REFLECT_ARCHETYPE = 'archetype_reflected';
export const REFLECT_COMPETENCY = 'competency_reflected';
export const REFLECT_SKILL = 'skill_reflected';
export const CREATE_GOAL = 'goal_created';
